import React from "react";

import { useTestimonials } from "../../../hooks/useTestimonials";
import { applyHighlights } from "../../../utils/applyHighlights";

const FALLBACK_TESTIMONIALS = [
  {
    id: 1,
    text: "If you can change your mind, you can change",
    highlighted_words: ["your life"],
  },
  {
    id: 2,
    text: "This experience has shifted my view on AI—not as a replacement for human work, but as an",
    highlighted_words: ["amplifier of it"],
  },
  {
    id: 3,
    text: "I believe I have a more",
    highlighted_words: ["open-mind about AI"],
  },
  {
    id: 4,
    text: "The thoughtfully designed course materials sparked my",
    highlighted_words: ["curiosity in AI tools"],
  },
  {
    id: 5,
    text: "I was able to test the",
    highlighted_words: ["limits of AI"],
  },
  {
    id: 6,
    text: "AI could help bridge some",
    highlighted_words: ["communication gaps"],
  },
  {
    id: 7,
    text: "Knowing how to put AI to",
    highlighted_words: ["good use"],
  },
  {
    id: 8,
    text: "I now appreciate AI as a",
    highlighted_words: ["powerful partner"],
  },
];

const Testimonials: React.FC = () => {
  const { testimonials } = useTestimonials();
  const testimonialsToRender = testimonials.length
    ? testimonials
    : FALLBACK_TESTIMONIALS;

  return (
    <section id="section-testimonials" className="testimonial-one">
      <div className="container">
        <div className="section-title text-center">
          <div className="subtitle">[ Student Voices ]</div>
          <h2>Hear from 500+ Students</h2>
        </div>
        <div className="row">
          {testimonialsToRender.map((testimonial, index) => {
            const endsWithPunctuation = /[.!?]$/.test(testimonial.text.trim());
            return (
              <div
                key={testimonial.id ?? index}
                className="col-xl-3 col-lg-6 col-md-6"
              >
                <div className="testimonial-one__single">
                  <div className="testimonial-quote">
                    <div className="quote-mark"></div>
                    <p
                      className="quote-text"
                      dangerouslySetInnerHTML={{
                        __html:
                          applyHighlights(
                            testimonial.text,
                            testimonial.highlighted_words || []
                          ) + (endsWithPunctuation ? "" : "."),
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
